<template>
    <div class="us_app">
        <section class="user_section">
            <div class="title jc">
            </div>
                                  
            <article class="view cmnity">
                <div class="cate_detail">
                    <div class="img_box">
                        <img :src="'/file/getImgFile/' + promiseGoods.goods_file_id" alt="">
                    </div>
                    <div class="cate_info">
                        <h3>{{promiseGoods.promise_goods_nm}} / {{promiseGoods.promise_goods_type_nm}}/ {{promiseGoods.component_descript}}</h3>
                        
                        <div class="flex justify-between mt20 mb20">
                            <p>구매 상품 목록</p>
                            <div class="flex gap8">
                                <b-badge variant="danger" v-if="prescriptInfo.total_quantity <= 30">사전처방 필요</b-badge>
                                <b-badge variant="primary" v-if="prescriptInfo.total_quantity > 30">발송가능</b-badge>
                            </div>
                        </div>

                        <ul class="sales_info">
                            <li v-if="itemList.length == 0">
                                <div class="flex items-center gap8">
                                    <p>데이터가 없습니다.</p>
                                </div>
                            </li>
                            <li
                                v-for="(item, index) in itemList"
                                :key="index"
                                @click="fn_click_item(item, index)"
                                :class="{ on: index === clickItemIdx }"
                            >
                                <div class="flex items-center gap8">
                                <img 
                                    style="object-fit: cover"
                                    :src="'/file/getImgFile/' + promiseGoods.goods_file_id" 
                                    alt=""
                                    width="40px"
                                    height="40px"
                                >
                                <span>{{ item.item_nm }}</span>
                                </div>
                                <span class="text-nowrap">{{ formatPrice(item.item_price) }}</span>
                            </li>
                        </ul>
                        <ul class="sales_info mt10">
                            <li class="dummy">
                                <div>
                                    <p>사전처방 수량</p>
                                    <p>{{prescriptInfo.prescript_quantity}}</p>
                                </div>
                                <div>
                                    <p>처방한 수량</p>
                                    <p>{{prescriptInfo.use_quantity}}</p>
                                </div>
                                <div>
                                    <p>남은 수량</p>
                                    <p>{{prescriptInfo.total_quantity}}</p>
                                </div>
                            </li>
                        </ul>
                        <div class="action_info">
                            <div class="bottom_box border-0">
                                <button class="btn btn_md btn_brown" v-if="prescriptInfo.total_quantity <= 30"  @click="fn_prescrip_reg">사전처방 등록</button>
                                <button class="btn btn_md btn_blue" @click="fn_move_application">결제 및 발송요청</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail_product">
                    <div class="info">상세정보</div>
                </div>                
                <div class="product_detail">
                    <img :src="'/file/getImgFile/' + promiseGoods.goods_info_file_id" alt="">
                </div>
                <div class="bottom_box">
                    <button 
                        class="btn btn_md btn_darkbrown"
                        @click="fn_move_list_page"
                    >
                            목록
                    </button>
                </div>                
            </article>
            <prePrescriptRegistModal 
                :title="'사전처방등록'"
                :clinic_doctor_id="clinic_doctor_id"
                :promise_goods_cd="promiseGoodsCd"
                @callback="fn_prescrip_reg_complet"
            /> 
        </section>
        <alert-modal 
          :id="'alert'"
          :text="showAlertMsg" 
          :btnRight="'확인'" 
          :oneBtn="false"
          :isShow="showAlert"
          :className="'btn_brown'"
          v-on:update:showSetting="fn_showSet"
      />
    </div>
</template>

<script>

import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import prePrescriptRegistModal from '@/modal/user/prePrescriptRegistModal.vue'
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";

    export default {
        mixins: [commonUtil,alertutill],
        components: {
            AlertModal,
            prePrescriptRegistModal
        },
        data () {
            return {
                promiseGoodsCd : '',
                clinic_doctor_id : '',
                wrapperImgList : [],
                promiseGoods : {},
                prescriptInfo : {},
                itemList : [],
                itemInfo : null,
                clickItemIdx : 0,
                btnShow : false,
                salepromiseGoods : {
                    saleCount : 1,
                    selectBox : null,
                    selectWrapper : null
                },
            }
        },
        created(){
            this.promiseGoodsCd = this.$store.getters['promiseGoodsInfo/getPromiseGoodsCd'];
            this.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
            console.log("@@@@ promiseGoodsCd : "+this.promiseGoodsCd);

            //this.fn_search_wrapperImg();
            //this.fn_search_boxImg();
        },
        mounted(){
            this.fn_search(this.promiseGoodsCd);
        },
        methods : {
            fn_search(promiseGoodsCd){

                let param = new Object();
                param.promiseGoodsCd = promiseGoodsCd;
                param.clinicDoctorId = this.clinic_doctor_id;

                console.log("@@@@ param : %o",param);

                axios
                    .post("/api/user/promise/getPromiseGoods", param)
                    .then((res) => {

                        console.log("@@@@ res : %o",res.data);

                        this.promiseGoods = res.data.promiseGoods;          // 약속상품
                        this.prescriptInfo = res.data.prescriptInfo;        // 사전처방
                        this.itemList = res.data.itemList;                  // 구성상품 리스트

                        if(this.prescriptInfo.prescript_quantity - this.prescriptInfo.use_quantity <= this.salepromiseGoods.saleCount * this.promiseGoods.promise_goods_quantity) {
                            this.btnShow = true;
                        }else{
                            this.btnShow = false;
                        }
                        
                        //구성 상품 정보가 있을 경우 첫번째 아이템 선택 처리
                        if(this.itemList.length > 0){
                            this.fn_click_item(this.itemList[0],0);
                        }
                        
                        
                    })
                    .catch((err) => console.log(err));
                    
            },
            fn_move_list_page(){
                this.$store.dispatch('promiseGoodsInfo/setPromiseGoodsCd', ''); 
                this.$router.push("/promisGoodsList");
            },
            fn_prescrip_reg(){
                console.log("show modal");
                this.$bvModal.show("prePrescriptRegistModal");
            },
            fn_prescrip_reg_complet(){
                this.fn_search(this.promiseGoodsCd);
            },
            fn_move_application(){

                
                if(this.prescriptInfo.total_quantity <= 30){
                    let msg = "사전처방 등록이 필요합니다.";
                    this.fn_open_alert(msg); 
                    return;
                }else if(this.itemInfo.item_nm == null || this.itemInfo.item_nm == ''){
                    let msg = "구매 가능한 상품이 없습니다";
                    this.fn_open_alert(msg); 
                    return;
                }

                this.$store.dispatch('promiseGoodsInfo/setPromiseGoods', this.promiseGoods);
                this.$store.dispatch('promiseGoodsInfo/setPrescriptInfo', this.prescriptInfo);
                this.$store.dispatch('promiseGoodsInfo/setItemInfo', this.itemInfo);

                this.$router.push("/promiseGoods");
            },
            fn_click_item(item, index){
                this.clickItemIdx = index;
                this.itemInfo = item;
            }
        }
    }
</script>